import React, { useEffect, useRef, useState } from 'react';
import stylesDropdown from './dropdown.module.scss';
import { IoIosArrowDown } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import _ from 'underscore';

interface IDropdown {
  placeholder: string;
  visibleKey?: string;
  visiblePhrase?: (item: any) => string;
  label: string;
  list?: any;
  onChange: (e: any) => void;
  disabled?: boolean;
  currentOption?: any;
  className?: string;
  viewOnly?: boolean;
  fetchCall?: (e: any) => Promise<any>;
}

const useOutsideAlerter = (ref: any, callback: any) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (
        ref.current &&
        event &&
        event.target &&
        !ref.current.contains(event.target)
      ) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};

const CDropdown = (props: IDropdown) => {
  const [opened, setOpened] = useState(false);
  const [value, setValue] = useState('');
  const [selected, setSelected] = useState(null);
  const [filtered, setFiltered] = useState([]);
  // const [unfiltered, setUnFiltered] = useState([]);

  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const typingTimer: any = useRef(null);

  useOutsideAlerter(wrapperRef, () => setOpened(false));

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setValue(value);
    setOpened(true);
  };

  const clear = () => {
    setValue('');
    props.onChange(null);
  };

  useEffect(() => {
    setValue(
      props.visibleKey
        ? selected
          ? selected![props.visibleKey]
          : ''
        : selected && props.visiblePhrase!(selected) !== 'undefined'
        ? props.visiblePhrase!(selected)
        : ''
    );
  }, [props.visibleKey, selected, props.placeholder, props.visiblePhrase]);

  useEffect(() => {
    setSelected(props.currentOption);

    props.visibleKey &&
      props.currentOption &&
      setValue(props.currentOption[props.visibleKey]);
    // eslint-disable-next-line
  }, [props.currentOption]);

  useEffect(() => {
    // setUnFiltered(props.list);
    setFiltered(props.list);
  }, [props.list]);

  useEffect(() => {
    if (value && value.length === 0) {
      setOpened(false);
    }
  }, [value]);

  useEffect(() => {
    props.list &&
      !props.viewOnly &&
      setFiltered(
        props.list.filter((el: any) =>
          props.visibleKey
            ? el[props.visibleKey]
                .toLowerCase()
                .includes(value ? value.toLowerCase() : '')
            : props.visiblePhrase
            ? props
                .visiblePhrase(el)
                .toLowerCase()
                .includes(value ? value.toLowerCase() : '')
            : el.toLowerCase().includes(value ? value.toLowerCase() : '')
        )
      );
  }, [value, props]);

  useEffect(() => {
    typingTimer && clearTimeout(typingTimer.current);
    if (!_.isUndefined(props.fetchCall)) {
      if (!_.isEmpty(value) || value[value.length - 1] === ' ') {
        typingTimer.current = setTimeout(() => {
          props.fetchCall!(value).then(response => {
            if (response) {
              const { data } = response;
              setFiltered([data] as any);
            } else {
              setFiltered([]);
            }
          });
        }, 1000);
      } else {
        setFiltered([]);
      }
    }
  }, [value, props.fetchCall]);

  return (
    <section
      ref={wrapperRef}
      className={stylesDropdown.section + ' ' + props.className}
    >
      <label className={stylesDropdown.label}>{props.label}</label>
      {!props.disabled && (
        <>
          {opened ? (
            <IoClose className={stylesDropdown.arrow} onClick={clear} />
          ) : (
            <IoIosArrowDown
              className={stylesDropdown.arrow}
              onClick={() => setOpened(true)}
            />
          )}
        </>
      )}
      <div
        className={stylesDropdown.dropdown}
        ref={inputRef}
        onClick={() => setOpened(true)}
        id='inputDropdown'
      >
        {props.viewOnly ? (
          <p className='body-dark'>{value}</p>
        ) : (
          <input
            value={value}
            onChange={handleInputChange}
            placeholder={props.placeholder}
            onClick={() => setOpened(true)}
            disabled={props.disabled}
          />
        )}
      </div>

      <div
        className={opened ? stylesDropdown.list : stylesDropdown.closed}
        id='listDropdown'
        // style={styleList}
      >
        {filtered &&
          filtered.map((item: any, index: number) => (
            <option
              key={index}
              onClick={() => {
                setSelected(item);
                setOpened(false);
                props.onChange(item);
              }}
            >
              {props.visibleKey
                ? item[props.visibleKey]
                : props.visiblePhrase!(item)}
            </option>
          ))}
      </div>
    </section>
  );
};

export default CDropdown;
